/**
* java 版本：
* http://git.souche.com/hero/souche-qiwa/blob/master/qiwa-framework/src/main/java/com/souche/qiwa/util/CarImgUrlUtil.java
*
* ===
* 
* qiniu 文档：
* http://developer.qiniu.com/code/v6/api/kodo-api/image/imageview2.html
*
* ===
* 
* aliyun 文档：https://help.aliyun.com/document_detail/32217.html
* 
* e:1.缩放优先边，这里指定按短边优化 4.缩略优先边，缩略后填充必须指定值为4
* 
* c:是否进行裁剪。如果是想对图进行自动裁剪，必须指定为1
* 
* o:自动旋转，车辆照片使用2
* 
* p:倍数百分比。 小于100，即是缩小，大于100即是放大。
* 
* wh:只有当原图是四通道(即有透明背景)的png, webp, bmp转换成jpg格式时才有效果。即把原图当中的透明背景以白色填充，如果不指定wh,
* 那么上述图转换成jpg时，透明背景将会变成黑色。
*
* Q:不在页面上显示的图片、多倍显示的图片使用 60Q
* 
* @author Bolt.js 王春岩 前端研发部
*/

module.exports = {
	HTTP: 'http:',
	HTTPS: 'https:',
	QINIU_IMG_URL_WORD: '//',
	ALIYUN_IMG_URL_PRE: '//img.souche.com/',

	/**
	 * 一般方法
	 * 
	 * @param  String inputImg [description]
	 * @param  int width    [description]
	 * @param  int height   [description]
	 * @return String          [description]
	 */
	formatUrl: function (inputImg, width, height, ts) {
		if (!ts) {
			ts = '0'
		}
		if (width && height) {
			// 限制宽高
			if (!(width > 0 && height > 0)) {
				console.error("error:width/height不能小于0,当前width=" + width + "/height=" + height);
			}
			return this._formatUrl_v3(inputImg, 
				"@" + width + "w_" + height + "h_1e_1c_2o_60Q_1pr_200p_1wh.jpg?ts=" + ts, 
				"?imageView2/1/w/" + width*2 + "/h/" + height*2 + "/.jpg");
		}
		if (width) {
			// 限制宽度
			if (!(width > 0)) {
				console.error("error:width不能小于0,当前width=" + width);
			}
			return this._formatUrl_v3(inputImg, 
				"@" + width + "w_2o_60Q_1pr_200p_1wh.jpg?ts=" + ts, 
				"?imageView2/2/w/" + width * 2 + "/.jpg");
		}
		return this._formatUrl_v3(inputImg, 
			"@2o_60Q_1pr_200p_1wh.jpg?ts=" + ts, 
			"?imageView2/1/.jpg");
	},

	/**
	 *	H5 专用
	 * 
	 * @param  String inputImg [description]
	 * @param  int width    [description]
	 * @param  int height   [description]
	 * @return String          [description]
	 */
	formatH5Url: function (inputImg, width, height, ts) {
		return this.formatUrl(inputImg, width, height, ts);
	},

	/**
	 * 分享 logo 专用方法: 正方形，填充，白色背景填充。可自定义宽高
	 * 
	 * @param  String inputImg [description]
	 * @param  int width    [description]
	 * @return String          [description]
	 */
	formatShareImgUrl: function (inputImg, width) {
		if (width) {
			if (!(width > 0)) {
				console.error("error:width不能小于0,当前width=" + width);
			}
			return this._formatUrl_v3(inputImg, 
				"@" + width + "w_" + width + "h_4e_1wh_2o_60Q.jpg", 
				"?imageView2/1/w/" + width + "/h/" + width + "/.jpg");
		}
		return this._formatUrl_v3(inputImg, 
			"@300w_300h_4e_1wh_2o_60Q.jpg", 
			"?imageView2/1/w/300/h/300/.jpg");
	},

	formatBaiduImgUrl: function (inputImg, width, height) {
		if (!width || !height) {
			console.error("error:width/height不能为空");
		}
		return this._formatUrl_v3(inputImg, 
				"@" + width + "w_" + height + "h_4e_1wh_2o_60Q.jpg", 
				"?imageView2/1/w/" + width + "/h/" + height + "/.jpg");
	},

	/**
	 * H5Logo 专用方法：不得压缩，透明。H5Logo 全站唯一，可以有效利用缓存
	 * 
	 * @param  String inputImg [description]
	 * @return String          [description]
	 */
	formatH5LogoUrl: function (inputImg) {
		return this._formatUrl_v3(inputImg, 
			"@80h_200p.png", 
			"?imageView2/1/.png");
	},

	/**
	 * 底层方法，识别阿里云/七牛，添加相应后缀
	 * 
	 * @param  String inputImg 当前方法校验，调用方不需要校验
	 * @param  String _aliyun  [description]
	 * @param  String _qiniu   [description]
	 * @return String          [description]
	 */
	_formatUrl_v3: function (inputImg, _aliyun, _qiniu) {
		if (!inputImg) {
			console.error("error:inputImg不能为空,当前inputImg=" + inputImg);
		}
		var inputImgLowerCase = inputImg.toLowerCase();
		if (inputImgLowerCase.indexOf(this.HTTPS) == 0) {
			inputImgLowerCase = inputImgLowerCase.substring(this.HTTPS.length);
			inputImg = inputImg.substring(this.HTTPS.length);
		} else if (inputImgLowerCase.indexOf(this.HTTP) == 0) {
			inputImgLowerCase = inputImgLowerCase.substring(this.HTTP.length);
			inputImg = inputImg.substring(this.HTTP.length);
		}

		if (inputImgLowerCase.indexOf(this.ALIYUN_IMG_URL_PRE) == 0) {
			return (inputImg.indexOf('@') != -1)? inputImg: (inputImg + _aliyun);
		} else if (inputImgLowerCase.indexOf(this.QINIU_IMG_URL_WORD) == -1) {
			return (inputImg.indexOf('@') != -1)? 
				(this.ALIYUN_IMG_URL_PRE + inputImg): (this.ALIYUN_IMG_URL_PRE + inputImg + _aliyun);
		} else {
			return inputImg + _qiniu;
		}
	},

	/**
	 * *********************************************
	 * 以下方法均不建议使用
	 * *********************************************
	 */

	/**
	 * ！！！不建议使用
	 * @param  {[type]} imgUrl [description]
	 * @param  {[type]} config [description]
	 * @return {[type]}        [description]
	 */
	_format_QINIU: function (imgUrl, config) {
		return imgUrl + '?imageView2/1/w/' + config.width + '/h/' + config.height + '/.jpg';
	},

	/**
	 * ！！！不建议使用
	 * @param  {[type]} imgUrl [description]
	 * @param  {[type]} config [description]
	 * @return {[type]}        [description]
	 */
	_format_ALIYUN: function (imgUrl, config) {
		if (imgUrl.indexOf('@') != -1) {
			return imgUrl;
		}

		var _config = $.extend({
			e: 1,
			c: 1,
			i: 0,
			o: 2,
			x: 1,
			Q: 60,
			suffix: 'jpg'
		}, config);
		imgUrl += '@';
		imgUrl += _config.e +'e_';

		if (_config.width) {
			imgUrl += ~~_config.width + 'w_' ;
		}
		if (_config.height) {
			imgUrl += ~~_config.height + 'h_';
		}
		
		imgUrl += _config.c + 'c_';
		imgUrl += _config.i + 'i_';
		imgUrl += _config.o + 'o_';
		imgUrl += _config.Q + 'Q_';
		imgUrl += _config.x + 'x.';
		return imgUrl + _config.suffix;
	},

	/**
	 * ！！！不建议使用，第二版
	 * @param  {[type]} imgUrl [description]
	 * @param  {[type]} config [description]
	 * @return {[type]}        [description]
	 */
	_formatUrl_v2: function (imgUrl, config) {
		if (config.proportion) {
			if (!config.width) {
				if (!config.height) {
					config.width = 280;
					config.height = 280/config.proportion;
				} else {
					config.width = config.height*config.proportion;
				}
			} else {
				if (!config.height) {
					config.height = config.width/config.proportion;
				}
			}
		}
		
		if (imgUrl.indexOf(this.ALIYUN_IMG_URL_PRE) != -1) {
			// 阿里云
			return this._format_ALIYUN(imgUrl, config);
		} else if (imgUrl.indexOf(this.QINIU_IMG_URL_WORD) == -1) {
			// 阿里云
			return this._format_ALIYUN(this.ALIYUN_IMG_URL_PRE + imgUrl, config);
		} else {
			return this._format_QINIU(imgUrl, config);
		}
	},

	/**
	 * ！！！不建议使用，第一版
	 * @param  {[type]} imgUrl      [description]
	 * @param  {[type]} w           [description]
	 * @param  {[type]} h           [description]
	 * @param  {[type]} x           [description]
	 * @param  {[type]} suffix      [description]
	 * @param  {[type]} watermark_w [description]
	 * @return {[type]}             [description]
	 */
	_formatUrl: function (imgUrl, w, h, x, suffix, watermark_w) {
		if (!imgUrl) {
			return imgUrl;
		}
		if (!w) {
			w = 280;
		}
		if (!h) {
			h = w/4*3;
		}
		if (!suffix) {
			suffix = 'jpg';
		}
		if (!watermark_w || !window._qiwa.waterMark[watermark_w]) {
			watermark_w = false;
		}
		w = ~~w;
		h = ~~h;
		var realImgUrl = '';
		if (imgUrl.indexOf(this.ALIYUN_IMG_URL_PRE) != -1) {
			if (imgUrl.indexOf('@') == -1) {
				realImgUrl = imgUrl + '@1e_' + w + 'w_' + h + 'h_1c_0i_2o_100Q_' + x + 'x.' + suffix;
				if (watermark_w) {
					realImgUrl = realImgUrl + '%7C' + window._qiwa.waterMark[watermark_w].replace(/&amp;/g, '&');
				}
			} else {
				realImgUrl = imgUrl;
			}
		} else if (imgUrl.indexOf(this.QINIU_IMG_URL_WORD) == -1) {
			if (imgUrl.indexOf('@') == -1) {
				realImgUrl = this.ALIYUN_IMG_URL_PRE + imgUrl + '@1e_' + w + 'w_' + h + 'h_1c_0i_2o_100Q_' + x + 'x.' + suffix;
				if (watermark_w) {
					realImgUrl = realImgUrl + '%7C' + window._qiwa.waterMark[watermark_w].replace(/&amp;/g, '&');
				}
			} else {
				realImgUrl = this.ALIYUN_IMG_URL_PRE + imgUrl;
			}
		} else  {
			realImgUrl = imgUrl + '?imageView2/1/w/' + w*2 + '/h/' + h*2 + '/.jpg';
		}
		return realImgUrl;
	},

	/**
	 * ！！！不建议使用
	 * @param  {[type]} imgUrl [description]
	 * @param  {[type]} w      [description]
	 * @param  {[type]} h      [description]
	 * @return {[type]}        [description]
	 */
	formatUrl_m: function (imgUrl, w, h) {
		return this._formatUrl(imgUrl, w, h, 2);
	},

	/**
	 * ！！！不建议使用
	 * @param  {[type]} imgUrl [description]
	 * @param  {[type]} w      [description]
	 * @param  {[type]} h      [description]
	 * @return {[type]}        [description]
	 */
	formatUrlWithWater: function (imgUrl, w, h) {
		return this._formatUrl(imgUrl, w, h, 1, false, 'w' + w);
	},

	/**
	 * ！！！不建议使用
	 * @param  {[type]} imgUrl [description]
	 * @param  {[type]} w      [description]
	 * @param  {[type]} h      [description]
	 * @return {[type]}        [description]
	 */
	formatUrlWithWater_m: function (imgUrl, w, h) {
		return this._formatUrl(imgUrl, w, h, 2, false, 'w325');
	},

	/**
	 * ！！！不建议使用
	 * @param  {[type]} imgUrl [description]
	 * @param  {[type]} w      [description]
	 * @param  {[type]} h      [description]
	 * @return {[type]}        [description]
	 */
	formatLogo: function (imgUrl, w, h) {
		return this._formatUrl(imgUrl, w, h, 1, 'png');
	},

	/**
	 * ！！！不建议使用
	 * @param  {[type]} imgUrl [description]
	 * @param  {[type]} w      [description]
	 * @param  {[type]} h      [description]
	 * @return {[type]}        [description]
	 */
	formatLogo_m: function (imgUrl, w, h) {
		return this._formatUrl_v2(imgUrl, {
			height: h,
			x: 2,
			Q: 100,
			suffix: 'png'
		});
	}

};



//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/img-util/url-util.js
// module id = 63
// module chunks = 4